export default "__VITE_ASSET__BQAn7Bc9__"